import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';

import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withRoute } from '@yme/components/RouteHelper/RouteHelper';
import { withTranslation } from '@yme/services/i18n';

import ExperienceDetailsPage from './ExperienceDetailsPage';

export default MapTo(AEM_FUNCTIONS.experienceDetailsPage)(
  withTranslation(withComponentMappingContext(withRoute(ExperienceDetailsPage))),
);
